import styled from 'styled-components';

const FieldView = styled.div`
  display: flex;
  margin-bottom: 0.5em;
  box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.15);
  position: relative;
  cursor: pointer;
  &:hover {
    .inner .label, .inner input {
      transition: all 0.3s ease;
      background-color: var(--gray100);
    }
  }
  .inner {
    flex: 1;
    position: relative;
    color: inherit;
    &:not(:first-of-type) {
      border-left: 1px solid var(--gray300);
    }
    i {
      position: absolute;
      font-size: 2em;
      left: 0.5em;
      top: 0.5em;
    }
    input {
      height: 4em;
      width: 100%;
      outline: none;
      background-color: var(--gray0);
      padding: 0.5em 1.5em;
      padding-left: 4em;
      border: none;
      cursor: pointer;
      ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: var(--gray600);
      }
      ::-moz-placeholder { /* Firefox 19+ */
        color: var(--gray600);
      }
      :-ms-input-placeholder { /* IE 10+ */
        color: var(--gray600);
      }
      :-moz-placeholder { /* Firefox 18- */
        color: var(--gray600);
      }
    }
    .label {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      left: 4em;
      top: 0;
      height: 4em;
      width: calc(100% - 4em);
      background-color: var(--gray0);
      cursor: pointer;
      .main, .sub {
        margin: 0;
        line-height: 1.5em;
        letter-spacing: 0.5px;
      }
      .main {
        font-size: 1em;
      }
      .sub {
        font-size: 0.75em;
        color: var(--gray600);
      }
    }
  }
  @media (max-width: 480px) {
    .inner {
      i {
        left: 0.3em;
      }
      input {
        padding-left: 3em;
        height: 3.5em;
        /*::-webkit-input-placeholder {
          font-size: 14px;
        }
        ::-moz-placeholder {
          font-size: 14px;
        }
        :-ms-input-placeholder {
          font-size: 14px;
        }
        :-moz-placeholder {
          font-size: 14px;
        }*/
      }
      .label {
        left: 3em;
        height: 3em;
        top: 0.5em;
      }
    }
  }
`;

export default FieldView;
